export default "__VITE_ASSET__6f31e7ec__"